import { render, staticRenderFns } from "./commonEmptyWechat.vue?vue&type=template&id=687cd6f3&scoped=true"
import script from "./commonEmptyWechat.vue?vue&type=script&lang=js"
export * from "./commonEmptyWechat.vue?vue&type=script&lang=js"
import style0 from "./commonEmptyWechat.vue?vue&type=style&index=0&id=687cd6f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687cd6f3",
  null
  
)

export default component.exports